import { Injectable } from "@angular/core";
import { tap, zip } from "rxjs";
import { IndexedDBService } from "../indexed-db/indexed-db.service";
import { HttpClient } from "@angular/common/http";
import { ChecklistAnswer } from "src/app/api/bizzmine/checklist/checklist.service";
import { MediaService } from "../media/media.service";
import { Store } from "@ngrx/store";
import { formsActions } from "src/app/store/features/forms/forms-actions";
import { selectForm } from "src/app/store/features/forms/forms-selectors";

@Injectable({
	providedIn: "root",
})
export class ChecklistService {
	public constructor(
		private indexedDbService: IndexedDBService,
		private http: HttpClient,
		private mediaService: MediaService,
		private store$: Store
	) {
		
	}

	//remove all pending request for this form
	public removePendingRequests(formId: string): void {
		this.indexedDbService.getStore("checklistAnswers").then((data: { id: string; data: { url: string; formId:string, payload: any } }[]) => {
			if (data && data.length > 0) {
				data.forEach((item) => {
					//delete checklist answer if the formId is the same
					if (item.data.formId === formId) {
						this.indexedDbService.deleteData(
							"checklistAnswers",
							item.id
						);
					}
				});
			}
		});
	}
	
	public processPendingRequests(): void {
		// filter all records status unhandled Status 0

		//get all media files
		this.mediaService.processMediaUploadQueue().then((mediaData:[number, {
			index: number;
			key: string;
			fileSize: number;
			fileName: string;
		}][] ) => {
			// all media files are uploaded
			console.log("Pending media requests:", mediaData);
			// and then we can process the checklist answers
			// fetch all checklist answers 
			// and add attachments for the answers if there are
			
			this.indexedDbService
			.getStore("checklistAnswers")
			.then((data: { id: string; data: { url: string; payload: any } }[]) => {
				console.log("Pending requests:", data);
				if (data && data.length > 0) {
					let dataRequests$: any[] = [];
					data.forEach((item) => {
						// check for files map it!
						//return only the index of media data where the key is the same as item.id
						const attachments = mediaData.map(([num, obj ]) => {
							//only
							if (obj.key === item.id) {
								return {Id: num, Size: obj.fileSize, FileName: obj.fileName};
							}
						return;
						}).filter((num) => num !== undefined);
						console.log("Attachments:", attachments);
						if(attachments.length > 0) {
							item.data.payload.Attachments = item.data.payload.Attachments.concat(attachments);
						}
						

						dataRequests$.push(
							this.http.post<void>(item.data.url, item.data.payload).pipe(
								tap(() => {
									// if ok delete file + question data in db
									// async stuff
									this.indexedDbService.deleteData(
										"checklistAnswers",
										item.id
									);
									this.indexedDbService.deleteData(
										"media",
										item.id
									)
									return
								})
							)
						);
					});
					zip(dataRequests$).subscribe((res) => {
					
					});
				}
			});
			
		});

		
	}

	public storeChecklistAnswer(data: {
		collectionFormId: number,
		collectionId: number,
		instanceId: number,
		versionId: number,
		formFieldId: number,
		dataDesignViewDataSourcesId: number,
		formId: string,
        questionId: number,
		payload: ChecklistAnswer
	}): Promise<void> {
		const url = `api/checklist/viewdatasourcesid/${data.dataDesignViewDataSourcesId}/version/${data.versionId}`;
		const id = `${data.collectionFormId}_${data.collectionId}_${data.formFieldId}_${data.instanceId}_${data.versionId}_${data.questionId}`;
		return this.indexedDbService.saveData("checklistAnswers", {
			id: id,
			data: { payload: data.payload, formId: data.formId, url: url },
		});
	}

	public getTotalPendingRequests(): Promise<number> {
		return this.indexedDbService.getStore("checklistAnswers").then((data: { id: string; data: { url: string; payload: any } }[]) => {
			return data.length;
		});
	}
}
